<template>
    <div class="key-data-sup-black-info">
        <div class="title-container">
            <span class="sub-title">基本信息</span>
            <i :class="contentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapse"></i>
        </div>
        <div class="content" v-if="contentVisible">
            <el-row>
                <el-col class="has-bg right-text" :span="3">供应商编码</el-col>
                <el-col :span="5">{{ formData.supplierCode }}</el-col>
                <el-col class="has-bg right-text" :span="3">供应商名称</el-col>
                <el-col :span="5">{{ formData.supplierName }}</el-col>
                <el-col class="has-bg right-text" :span="3">业务类型</el-col>
                <el-col :span="5">{{ formData.businessTypeBlack }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">社会信用代码</el-col>
                <el-col :span="5">{{ formData.societyCreditCode }}</el-col>
                <el-col class="has-bg right-text" :span="3">{{requestParams.property === '1' ? '法人代表' : '姓名'}}</el-col>
                <el-col :span="5">{{ formData.corporateName }}</el-col>
                <el-col class="has-bg right-text" :span="3">{{requestParams.property === '1' ? '法人' : ''}}身份证号</el-col>
                <el-col :span="5">{{ formData.idCard }}</el-col>
            </el-row>
        </div>
        <!-- 洗白信息 -->
        <div class="title-container" v-if="isWhite">
            <span class="sub-title">洗白信息</span>
            <i :class="whiteWashVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleWhiteWashCollapse"></i>
        </div>
        <div class="content" v-if="isWhite && whiteWashVisible">
            <el-row>
                <el-col class="has-bg right-text" :span="3">洗白类型</el-col>
                <el-col :span="5">{{ formData.whiteWashingType }}</el-col>
                <el-col class="has-bg right-text" :span="3">洗白原因</el-col>
                <el-col :span="5">{{ formData.whiteReason }}</el-col>
                <el-col class="has-bg right-text" :span="3">系统自动拉黑</el-col>
                <el-col :span="5">{{ formData.systemBlackDay }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">黑名单原因</el-col>
                <el-col :span="5">{{ formData.reason }}</el-col>
                <el-col class="has-bg right-text" :span="3">违规主题</el-col>
                <el-col :span="5">{{ formData.title }}</el-col>
                <el-col class="has-bg right-text" :span="3">违规行为描述</el-col>
                <el-col :span="5">{{ formData.behaviorDesc }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">附件信息</el-col>
                <el-col :span="21" ref="qlfColRef">
                    <el-button class="preview-btn" v-for="item in qualificationInfos" :key="item.fileId" type="text" @click="handlePreview(item)">{{ item.fileName }}</el-button>
                </el-col>
            </el-row>
        </div>
        <!-- 违规信息 -->
        <div class="title-container" v-if="isBlack">
            <span class="sub-title">违规信息</span>
            <i :class="violationVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleViolationCollapse"></i>
        </div>
        <div class="content" v-if="isBlack && violationVisible">
            <el-row>
                <el-col class="has-bg right-text" :span="3">违规主题</el-col>
                <el-col :span="5">{{ formData.title }}</el-col>
                <el-col class="has-bg right-text" :span="3">黑名单原因</el-col>
                <el-col :span="5">{{ formData.reason }}</el-col>
                <el-col class="has-bg right-text" :span="3">黑名单时效</el-col>
                <el-col :span="5">{{ formData.prescription }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">违规行为描述</el-col>
                <el-col :span="5">{{ formData.behaviorDesc }}</el-col>
                <el-col class="has-bg right-text" :span="3">关联公文号</el-col>
                <el-col :span="5">{{ formData.documentNumber }}</el-col>
                <el-col class="has-bg right-text" :span="3">公文链接</el-col>
                <el-col :span="5">{{ formData.documentUrl }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">附件信息</el-col>
                <el-col :span="21" ref="qlfColRef">
                    <el-button class="preview-btn" v-for="item in qualificationInfos" :key="item.fileId" type="text" @click="handlePreview(item)">{{ item.fileName }}</el-button>
                </el-col>
            </el-row>
        </div>
        <template v-if="isBlack">
            <!-- 拉黑范围 -->
            <div class="title-container">
                <span class="sub-title">拉黑范围</span>
                <i :class="rangeVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="rangeVisible = !rangeVisible"></i>
            </div>
            <blackRangeList v-show="rangeVisible" :requestParams="requestParams"/>
        </template>
        <Preview
            v-if="attachmentShow"
            :attachmentList="attachmentList"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></Preview>
    </div>
</template>

<script>
import { getBlackAudit, getWhiteAudit } from '../../../../api/register/aublacklist.js'
import { dictWithUrl } from '@/components/lots/api'
import Preview from '../../../../components/viewAttachment.vue';
import blackRangeList from './blackRangeList.vue'

export default {
    components: { Preview, blackRangeList },
    props: {
        auditId: {
            type: String,
            default: ''
        },
        isWhite: {
            type: Boolean,
            default: false
        },
        isBlack: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            rangeVisible: true,
            contentVisible: true,
            violationVisible: true,
            whiteWashVisible: true,
            dictData: {},
            formData: {
                supplierCode: '-',
                supplierName: '-',
                businessTypeBlack: '-',
                societyCreditCode: '-',
                businessLicenseNo: '-',
                orgCode: '-',
                corporateName: '-',
                idCard: '-',
                corporateMobile: '-',
                title: '-',
                reason: '-',
                prescription: '-',
                behaviorDesc: '-',
                documentNumber: '-',
                documentUrl: '-',
                whiteWashingType: '',
                systemBlackDay: '-',
                whiteReason: '-',
            },
            qualificationInfos: [],
            attachmentShow: false,
            rowData: {},
            attachmentList: [],
            requestParams: {},
        }
    },
    mounted() {
        this.loadDictData()
    },
    methods: {
        loadDictData() {
            dictWithUrl('SRM_BUSYNESS_TYPE_BLACK,SRM_BLACKLIST_REASON,SRM_BLACKLIST_PRESCRIPTION,WHITE_WASHING_TYPE,SYSTEM_BLACK_DAY')
                .then(res => {
                    if (res && +res.code === 0) {
                        this.dictData = res.data
                        this.loadData()
                    }
                })
                .catch(err => {})
        },
        loadData() {
            if (!this.auditId || (!this.isWhite && !this.isBlack)) return
            const apiFunc = this.isWhite ? getWhiteAudit : (this.isBlack ? getBlackAudit : null)
            apiFunc({ fdId: this.auditId }).then(res => {
                if (res && +res.code === 0) {
                    this.setFormData(res.data)
                    this.setQualificationList(res.data.qualificationInfos)
                }
            }).catch(err => {})
        },
        setFormData(data) {
            if (!data) return
            this.requestParams = {
                societyCreditCode: data.societyCreditCode,
                idCard: data.idCard,
                property: data.property,
                auditMipId: this.auditId
            }
            this.formData.supplierCode = data.supplierCode || '-'
            this.formData.supplierName = data.supplierName || '-'
            this.formData.businessTypeBlack = this.dictData.SRM_BUSYNESS_TYPE_BLACK[data.businessTypeBlack] || '-'
            this.formData.societyCreditCode = data.societyCreditCode || '-'
            this.formData.businessLicenseNo = data.businessLicenseNo || '-'
            this.formData.orgCode = data.orgCode || '-'
            this.formData.corporateName = data.corporateName || '-'
            this.formData.idCard = data.idCard || '-'
            this.formData.corporateMobile = data.corporateMobile || '-'
            
            // 违规信息
            this.formData.title = data.title || '-'
            this.formData.reason = this.dictData.SRM_BLACKLIST_REASON[data.reason] || '-'
            this.formData.prescription = this.dictData.SRM_BLACKLIST_PRESCRIPTION[data.prescription] || '-'
            this.formData.behaviorDesc = data.behaviorDesc || '-'
            this.formData.documentNumber = data.documentNumber || '-'
            this.formData.documentUrl = data.documentUrl || '-'
            
            // 洗白信息
            this.formData.whiteWashingType = this.dictData.WHITE_WASHING_TYPE[data.whiteWashingType] || ''
            this.formData.systemBlackDay = this.dictData.SYSTEM_BLACK_DAY[data.systemBlackDay] || '-'
            this.formData.whiteReason = data.whiteReason || '-'
        },
        setQualificationList(data) {
            const qualificationInfos = []
            const attachmentList = []
            if (data && data.length) {
                data.forEach(item => {
                    if (item.fileUrl) {
                        qualificationInfos.push({
                            // id: item.id,
                            // qualificationName: item.qualificationName,
                            fileUrl: item.fileUrl,
                            fileName: item.fileName,
                            fileId: item.fileId,
                        })
                    }
                    attachmentList.push(item.fileUrl)
                })
            }
            this.qualificationInfos = qualificationInfos
            this.attachmentList = attachmentList.filter(item => !!item)
        },
        handlePreview(data) {
            this.rowData = {
                downUrl: data.fileUrl,
                fileName: data.fileName,
                fileId: data.fileId
            };
            this.attachmentShow = true;
        },
        handleCollapse() {
            this.contentVisible = !this.contentVisible
        },
        handleViolationCollapse() {
            this.violationVisible = !this.violationVisible
        },
        handleWhiteWashCollapse() {
            this.whiteWashVisible = !this.whiteWashVisible
        }
    },
    // watch: {
    //     auditId: {
    //         handler(newVal) {
    //             if (newVal) {
    //                 this.loadData()
    //             }
    //         },
    //         immediate: true
    //     }
    // }
}
</script>

<style lang="less">
.key-data-sup-black-info {
    margin-bottom: 20px;
    font-size: 14px;
    color: #000;

    .el-row {
        display: flex;
    }

    .el-col {
        float: none;
    }

    .sub-title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-top: 15px;
        margin-bottom: 5px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }

    .content {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .has-bg {
        background: #f5f7fa;
    }

    .right-text {
        text-align: right;
    }

    .el-col {
        padding: 5px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        min-height: 30px;
        word-break: break-all;
    }
}
</style> 